import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
import { fetchUpgradableCyclesQueryFn } from './queryFn/fetchUpgradableCycles/fetchUpgradableCycles.query';
import { getCurrentProductQueryFn } from './queryFn/getCurrentProduct';
import { getCurrentProductStatusQueryFn } from './queryFn/getCurrentProductStatus.query';
import { hasUpgradableCyclesQueryFn } from './queryFn/hasUpgradableCycles.query';
import { isCurrentProductQueryFn } from './queryFn/isCurrentProduct.query';
import { isCycleAvailableQueryFn } from './queryFn/isCycleAvailable.query';
import { isSameProductFamilyQueryFn } from './queryFn/isSameProductFamily.query';
import { isSwitchFlowQueryFn } from './queryFn/isSwitchFlow.query';
import { lowestCycleAvailableQueryFn } from './queryFn/lowestCycleAvailable.query';
export const UpgradeQueriesConfig = createQueriesConfig({
  fetchUpgradableCycles: {
    queryFn: fetchUpgradableCyclesQueryFn
  },
  getCurrentProduct: {
    queryFn: getCurrentProductQueryFn
  },
  isSwitchFlow: {
    queryFn: isSwitchFlowQueryFn
  },
  isSameProductFamily: {
    queryFn: isSameProductFamilyQueryFn
  },
  isCurrentProduct: {
    queryFn: isCurrentProductQueryFn
  },
  hasUpgradableCycles: {
    queryFn: hasUpgradableCyclesQueryFn
  },
  isCycleAvailable: {
    queryFn: isCycleAvailableQueryFn
  },
  lowestCycleAvailable: {
    queryFn: lowestCycleAvailableQueryFn
  },
  getCurrentProductStatus: {
    queryFn: getCurrentProductStatusQueryFn
  }
});
//# sourceMappingURL=upgrade.config.js.map